import Spacer from '@berlitz/spacer'
import AtRiskNotificationCard from '@components/AtRiskNotificationCard'
import HR from '@components/HR'
import HeaderWithClock from '@components/PageHeader'
import PageTitle from '@components/PageTitle'
import WithPortalAuthorization from '@hocs/WithPortalAuthorization'
import MyMediaLayout from '@layouts/MyMedia'
import React from 'react'
import { Col, Row } from 'react-styled-flexboxgrid'

const MyMedia: React.FC = () => (
  <>
    <PageTitle title={'My Media'} />
    <HeaderWithClock title="My Media" />
    <Row>
      <Col xs={12} md={12} lg={6}>
        <AtRiskNotificationCard />
      </Col>
    </Row>
    <HR />
    <Spacer />
    <MyMediaLayout />
  </>
)

export default WithPortalAuthorization(MyMedia, {
  id: 'page::my-media',
})
